import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;
const REFUND_STORAGE_KEY = "reception_refunds";

const getRefundedAmountForItem = (item) => {
  try {
    const refunds = JSON.parse(localStorage.getItem(REFUND_STORAGE_KEY) || "[]");
    return refunds
      .filter((r) => String(r?.item_id) === String(item?.id) && String(r?.item_type) === String(item?.type))
      .reduce((sum, r) => sum + (Number(r?.amount) || 0), 0);
  } catch {
    return 0;
  }
};

const ReceiptPrint = ({ data }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");
  const ticket = data?.ticket || {};
  const item = data?.item || {};
  const netAmount = Number(item?.amount || item?.total_amount || 0);
  const discount = Number(item?.discount ?? item?.discount_amount ?? 0);
  const refunded = getRefundedAmountForItem(item);
  const printableAmount = Math.max(0, netAmount - refunded);

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      orderLine={{ label: `${t("print.ticketNumber")}:`, value: ticket.ticket_number || "-" }}
      rows={[
        { label: `${t("print.patientName")}:`, value: ticket.patient_name || "-" },
        { label: `${t("reception.type", "Type")}:`, value: item.type_display || item.label || "-" },
        ...(item.doctor_display ? [{ label: `${t("pharmacy.doctor")}:`, value: item.doctor_display }] : []),
        ...(item.date ? [{ label: `${t("reception.date")}:`, value: item.date }] : []),
      ]}
      totals={[
        ...(discount > 0 ? [{ label: t("reception.discount", "Discount"), value: money(discount) }] : []),
        ...(refunded > 0 ? [{ label: t("reception.refund", "Refund"), value: money(refunded) }] : []),
        { label: t("print.totalAmount"), value: money(printableAmount), bold: true },
      ]}
      footerLines={[t("print.thanks"), t("print.getWellSoon"), t("print.cosmos")]}
    />
  );
};

export default ReceiptPrint;
